import * as React from "react";
// Remember that all const are suffix _svg

const next_svg = (
  <svg className="next_svg" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1363_2439)">
      <circle
        cx="30.3673"
        cy="30.3673"
        r="29.7347"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0.632812 0.632568)"
        stroke="#161616"
        strokeWidth="1.26531"
      />
      <g clipPath="url(#clip1_1363_2439)">
        <path d="M41.7554 31.1506L16.4492 31.1506" stroke="#161616" strokeWidth="1.26531" strokeLinejoin="round" />
        <path
          d="M36.2119 24.0333C38.9325 26.7539 40.4579 28.2793 43.1785 30.9999L36.2119 37.9666"
          stroke="#161616"
          strokeWidth="1.26531"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1363_2439">
        <rect width="62" height="62" fill="white" transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)" />
      </clipPath>
      <clipPath id="clip1_1363_2439">
        <rect
          width="20.2449"
          height="94.898"
          fill="white"
          transform="matrix(4.37114e-08 1 1 -4.37114e-08 -46.1836 20.8774)"
        />
      </clipPath>
    </defs>
  </svg>
);
const prev_svg = (
  <svg className="prev_svg" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1363_2438)">
      <circle
        cx="30.9998"
        cy="30.9999"
        r="29.7347"
        transform="rotate(90 30.9998 30.9999)"
        stroke="#161616"
        strokeWidth="1.26531"
      />
      <g clipPath="url(#clip1_1363_2438)">
        <path d="M20.2446 31.1506L45.5508 31.1506" stroke="#161616" strokeWidth="1.26531" strokeLinejoin="round" />
        <path
          d="M25.7881 24.0333C23.0675 26.7539 21.5421 28.2793 18.8215 30.9999L25.7881 37.9666"
          stroke="#161616"
          strokeWidth="1.26531"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1363_2438">
        <rect width="62" height="62" fill="white" transform="translate(62) rotate(90)" />
      </clipPath>
      <clipPath id="clip1_1363_2438">
        <rect width="20.2449" height="94.898" fill="white" transform="translate(108.184 20.8774) rotate(90)" />
      </clipPath>
    </defs>
  </svg>
);

const cross_svg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 20.536 20.536" className="cross_svg">
    <line
      id="Line_38"
      data-name="Line 38"
      x2="17"
      y2="17"
      transform="translate(1.768 1.768)"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="2"
    />
    <line
      id="Line_39"
      data-name="Line 39"
      y1="17"
      x2="17"
      transform="translate(1.768 1.768)"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="2"
    />
  </svg>
);

export { cross_svg, next_svg, prev_svg };
